<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-card class="mx-auto" max-width="400">
				<v-card-subtitle class="pt-4 text-center blue--text">
					میزان اعتبار فعلی شما: {{ smsCredit.toString().toPriceFormat() }} تومان
				</v-card-subtitle>
				<v-spacer />
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-text-money class="align-center" v-model="amount" label="مبلغ مورد نظر جهت شارژ (تومان):" :error-messages="errorMessages" :rules="[() => amount >= 10000 || 'مبلغ را به صورت صحیح وارد کنید']" required />
							<small>حداقل مبلغ شارژ 10 هزار تومان می باشد</small>
						</v-col>
					</v-row>

				</v-card-text>

				<v-card-actions class="d-flex align-center justify-center">
					<v-btn color="orange" type="submit" :loading="submitLoading">
						پرداخت
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { get } from 'vuex-pathify'

	export default {
		name: 'SmsCreditCharge',
		props: {
			data: { type: Object },
		},
		data() {
			return {
				errorMessages: '',
				payable: 0,
				amount: 0,
				localData: {},
				submitLoading: false
			}
		},
		computed: {
			...get('appSettings', [
				'settings',
			]),
			smsCredit() {
				return this.settings?.smsCredit || 0
			},
		},
		mounted() {
			this.amount = 10000
		},
		methods: {
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				let data = {
					amount: this.amount,
					productType: 2,
					paymentMethod: 0
				}
				api.post('admin/purchase/create', data)
					.then(response => {
						window.location.replace(response)
					})
					.catch(err => {
						this.submitLoading = false
						toast.error(err.message)
					})
			}
		},
	}
</script>
<style>
</style>
